module.exports = __webpack_public_path__ + "media/images/sp/site_navigation/icon_report-77bfdf0ebcdf8666ed5633ab2b5f8ebe.svg";